import styled from "@emotion/styled"
import { FlexContainer } from "../../../../styled/flexbox.styled"

export const MainContainer = styled(FlexContainer)({
  height: "100%",
  width: "100%",
})
